import { render, staticRenderFns } from "./PerfilPublico.vue?vue&type=template&id=0badaffa&scoped=true&"
import script from "./PerfilPublico.vue?vue&type=script&lang=ts&"
export * from "./PerfilPublico.vue?vue&type=script&lang=ts&"
import style0 from "./PerfilPublico.vue?vue&type=style&index=0&id=0badaffa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0badaffa",
  null
  
)

export default component.exports